var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('filter-label');
import { breakpoints, theme } from '@shapeable/theme';
export var FilterLabelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-weight: 400;\n    line-height: 1em;\n    background: ", ";\n    padding: ", " ", " ", ";\n    font-size: ", ";\n\n    ", "\n  "], ["\n    text-transform: uppercase;\n    font-weight: 400;\n    line-height: 1em;\n    background: ", ";\n    padding: ", " ", " ", ";\n    font-size: ", ";\n\n    ", "\n  "])), theme.COLOR('formHeader'), theme.UNIT(2), theme.UNIT(4), theme.UNIT(2.25), theme.FONT_SIZE(14), function (props) {
    return props.hasValue && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      font-weight: 500;\n    "], ["\n      color: ", ";\n      font-weight: 500;\n    "])), theme.COLOR('strong'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var FilterLabel = function (props) {
  var className = props.className,
    children = props.children;
  return React.createElement(My.Container, {
    hasValue: true,
    className: cls.name(className)
  }, children, ":");
};
FilterLabel.defaultProps = FilterLabelDefaultProps;
FilterLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;